/**
 * Created by Pankaj on 23-Sep-2019
 */

import {IRomanEmpireServerData} from "./data/IRomanEmpireServerData";
import {RomanEmpireGameMode} from "../gamemode/RomanEmpireGameMode";
import {SpinServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinServerDataParser";
import {IBetLineBothWayWinData} from "./data/RomanEmpireParsedGameData";

export class RomanEmpireServerDataParser extends SpinServerDataParser {
    constructor() {
        super();
    }

    public getIsNextGenieFreeSpin(data: IRomanEmpireServerData) {
        return data.nextMode == RomanEmpireGameMode.GENIE_RESPIN;
    }

    public getNumberOfRespinPlayed(data: IRomanEmpireServerData): number {
        return data.numberOfRespinPlayed;
    }

    public  getOverlayWildsScatter(data: IRomanEmpireServerData) {
        return data.overlayMultiplierWilds;
    }

    public getNewOverlayWilds(data: IRomanEmpireServerData) {
        return data.newOverlayWilds;
    }

    public getWildMultipliers(data: IRomanEmpireServerData) {
        return data.wildMultipliers;
    }

    public getAccumulatedRoundWin(data: IRomanEmpireServerData): string {
        return data.accumulatedRoundWin;
    }

    public getTotalSpinWinningsMultiplied(data: IRomanEmpireServerData): number {
        return data.totalSpinWinningsMultiplied;
    }

    public getWildMultipliersNextSpin(data: IRomanEmpireServerData): number[][] {
        return data.wildMultipliersNextSpin;

    }

    public parseFreespinsLeft(data: IRomanEmpireServerData): number {
        return data.respinsRemaining !== null ? data.respinsRemaining - 1 : 0;
    }

    public getGenieOverlayWilds(data: IRomanEmpireServerData): boolean[][] {
        return data.genieOverlayWilds;
    }

    public getGenieSymbolTriggerPositions(data: IRomanEmpireServerData): boolean[][] {
        return data.genieSymbolTriggerPositions;
    }

    public isGenieFeatureTriggered(data: IRomanEmpireServerData): boolean {
        return data.genieFeatureTriggered;
    }

    public getGenieFeatureAwarded(data: IRomanEmpireServerData): string {
        return data.genieFeatureAwarded;
    }

    public getGenieExtraScatter(data: IRomanEmpireServerData): number[] {
        return data.genieExtraScatter;
    }

    public getGenieTimesBetCoinWin(data: IRomanEmpireServerData): number {
        return data.genieTimesBetCoinWin;
    }

    public getNumberOfGeniesInFS(data: IRomanEmpireServerData) {
        return data.numberOfGeniesInFS;
    }

    public getIsRestoreState(data: IRomanEmpireServerData) {
        return data.isRestoreState;
    }
    public getBothWayWins(data: IRomanEmpireServerData) : IBetLineBothWayWinData[] {
        return data.bothWayWins;
    }

    public isRandomBothWaysTriggered(data: IRomanEmpireServerData) : boolean {
        return data.randomBothWaysTriggered;
    }
    public getMultiplierOverlays(data: IRomanEmpireServerData) : number[][] {
        return data.multiplierOverlays;
    }

    public getGoldenGeniePositionCurrent(data: IRomanEmpireServerData) : number[] {
        return data.goldenGeniePositionCurrent;
    }

    public getGoldenGenieMultiplierNextSpin(data: IRomanEmpireServerData) : number {
        return data.goldenGenieMultiplierNextSpin;
    }

    public getGoldenGeniePositionNextSpin(data: IRomanEmpireServerData) : number[] {
        return data.goldenGeniePositionNextSpin;
    }

    public getGoldenGeniePositionPreviousSpin(data: IRomanEmpireServerData) : number[] {
        return data.goldenGeniePositionPreviousSpin;
    }

    public isNoGenieSpin(data: IRomanEmpireServerData): boolean {
        return data.isNoGenieSpin;
    }



}